// utils/generateCoverUrl.ts

import { buildOgpUrlByRlBookId, buildOgpUrlByTitle } from '../config/api';

interface PartialBookDetail {
  MainTitle: string;
  ContentDetailTitle?: string;
  TitleOthers?: string;
  ISBN?: string;
}

export const generateCoverUrl = (book: PartialBookDetail): string => {
  const title = `${book.MainTitle}${book.ContentDetailTitle || ''}${book.TitleOthers || ''}`;
  return buildOgpUrlByTitle(title, book.ISBN);
};

/**
 * title + isbn13 から直接カバー画像 URL を生成
 * 新 API レスポンスのフラットなデータから使う用
 */
export const generateCoverUrlFromTitleIsbn = (title: string, isbn13?: string): string => {
  return buildOgpUrlByTitle(title, isbn13);
};

/**
 * rl_book_id があれば `?rl_book_id=` ベースの URL を、無ければ title/isbn ベースに
 * フォールバックする。
 *
 * 2026-08-26: 以前は「バックエンドが返す生の cover_url（Amazon 等への直リンク、
 * CloudFrontキャッシュを通らない）があればそれを優先し、無ければ /ogp にフォール
 * バックする」というページが複数あった（関連書籍パネル・お気に入り・ハイライト等）。
 * これだと同じ本でもページによって別々のURL（キャッシュ有無もバラバラ）を掴む
 * ことになり、①CloudFrontの10年キャッシュの恩恵を受けられないページが残る
 * ②title文字列のわずかな差異（結合方法の違い等）で /ogp 側のキャッシュキーすら
 * ページ間で一致しない、という2つの問題があった。rl_book_id は同じ本なら
 * 常に同一の値なので、これをキャッシュキーの基準に統一する
 */
export const generateCoverUrlSmart = (
  rlBookId?: number | string | null,
  title?: string | null,
  isbn13?: string | null,
): string => {
  if (rlBookId != null && rlBookId !== '') {
    const idNum = typeof rlBookId === 'string' ? parseInt(rlBookId, 10) : rlBookId;
    if (!Number.isNaN(idNum)) return buildOgpUrlByRlBookId(idNum);
  }
  return buildOgpUrlByTitle(title ?? '', isbn13 ?? undefined);
};
